export default "__VITE_ASSET__CeX2g6k9__"